import * as React from 'react';

import type { ProgramAdminCatalogPermissionsType } from 'bundles/enterprise-admin-program-catalog/components/ProgramAdminTypeAndPermissionsContextProvider';
import { useProgramAdminTypeAndPermissionsContext } from 'bundles/enterprise-admin-program-catalog/components/ProgramAdminTypeAndPermissionsContextProvider';

type Props = {
  requiredPermissions: ProgramAdminCatalogPermissionsType[];
};

const ProgramAdminPermissionsRequired: React.LegacyFunctionComponentWithChildren<Props> = ({
  children,
  requiredPermissions,
}) => {
  const { hasAllRequiredPermissions } = useProgramAdminTypeAndPermissionsContext();
  if (!hasAllRequiredPermissions(requiredPermissions)) {
    return null;
  }

  return <>{children}</>;
};

export default ProgramAdminPermissionsRequired;
